export default "__VITE_ASSET__zp$oF$WF__"